import { Lightning as lng, Registry } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

const _constants = {
  ChannelNumberInput: {
    width: 100,
    height: 60,
  },
};

export default class ChannelNumberDisplay extends lng.Component<lng.Component.TemplateSpecLoose> {
  private savedKeys = '';
  private keyEnteringTimeout?: number;

  static override _template(): lng.Component.Template<lng.Component.TemplateSpecLoose> {
    return {
      visible: false,
      rect: true,
      color: Theme.Colors.ChannelNumberSelector.background,
      w: _constants.ChannelNumberInput.width,
      h: _constants.ChannelNumberInput.height,
      ChannelNumber: {
        mountX: 0.5,
        mountY: 0.45,
        x: (w: number) => w / 2,
        y: (h: number) => h / 2,
        text: {
          text: '',
          fontSize: 50,
          textAlign: 'center',
        },
      },
    };
  }

  numberEvent(e: KeyboardEvent) {
    const keyEnteringTimeoutTime = 1000;

    if (!this.savedKeys) this.savedKeys = '';
    if (this.savedKeys.length < 3) {
      this.savedKeys = this.savedKeys.concat(e.key);
    } else {
      this.savedKeys = e.key.toString();
    }
    this.displayChannelNumber(this.savedKeys);
    if (this.keyEnteringTimeout) Registry.clearTimeout(this.keyEnteringTimeout);

    this.keyEnteringTimeout = Registry.setTimeout(() => {
      const chanNum = parseInt(this.savedKeys, 10);
      this.savedKeys = '';
      this.signal('channelNumberTriggered', chanNum);
      this.hideChannelNumber();
    }, keyEnteringTimeoutTime);
  }

  displayChannelNumber(number: string) {
    this.visible = true;
    this.tag('ChannelNumber').text.text = number;
  }

  hideChannelNumber() {
    this.visible = false;
  }
}
